// extracted by mini-css-extract-plugin
export var hideEditor = "_ih-2";
export var infoIcon = "_ih-3";
export var label = "_ih-1";
export var labelContainer = "_ih-0";
export var readonlyText = "_ih-4";